import { render } from "./view.vue?vue&type=template&id=1700c0a2"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=1700c0a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__